// extracted by mini-css-extract-plugin
module.exports = {"Editor__navbar":"SyntaxPad_Editor__navbar__nOFCv","Menu__options":"SyntaxPad_Menu__options__10prO"};